/* Wise V23 « Hiver » — effets globaux (agent E).
   Chargé en defer, sans dépendance.
   1. Apparitions au défilement : [data-reveal], [data-reveal-stagger] + cartes / titres
      non pris en charge par wise.js (classes .reveal / .reveal-stagger).
   2. Variable --v23-sticky-top : bas du header visible, pour les barres collantes.
   3. Tiroir de filtres mobile sur les pages collection / recherche (snippet facets).
   4. Neige légère sur l'accueil (réglage v23_snow -> attribut data-snow sur <html> ou <body>). */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduced = !!(mqReduce && mqReduce.matches);

  /* Ce fichier peut être chargé (defer) avant wise.js : on attend DOMContentLoaded,
     qui part après tous les scripts defer, pour voir les classes .reveal posées par wise.js. */
  function ready(fn) {
    var done = false;
    function run() { if (done) return; done = true; fn(); }
    if (doc.readyState === 'complete') { run(); return; }
    doc.addEventListener('DOMContentLoaded', run);
    window.addEventListener('load', run);
  }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  /* ---------- 1. Apparitions au défilement ---------- */
  function initReveal() {
    var targets = [];
    var staggers = all('[data-reveal-stagger]');

    all('[data-reveal]').forEach(function (el) { targets.push(el); });

    /* Automatique, prudent : uniquement ce que wise.js n'anime pas déjà. */
    all('.card, .sec__title, .plp-hero__in').forEach(function (el) {
      if (el.hasAttribute('data-no-reveal')) return;
      if (el.closest('.reveal, .reveal-stagger, [data-reveal], [data-reveal-stagger], .drawer, .modal, .side, dialog')) return;
      if (el.classList.contains('reveal')) return;
      targets.push(el);
    });

    if (reduced || !('IntersectionObserver' in window)) {
      return; /* rien n'est masqué : contenu visible d'office */
    }

    targets.forEach(function (el) { el.classList.add('v23-reveal'); });
    staggers.forEach(function (el) { el.classList.add('v23-reveal-stagger'); });

    var io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.classList.contains('v23-reveal')) {
          el.style.transitionDelay = Math.min(n, 5) * 70 + 'ms';
          n++;
        }
        el.classList.add('is-in');
        io.unobserve(el);
        setTimeout(function () { el.style.transitionDelay = ''; }, 900);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

    targets.concat(staggers).forEach(function (el) { io.observe(el); });

    /* Filet de sécurité : rien ne doit rester invisible (impression, ancres, etc.). */
    window.addEventListener('beforeprint', function () {
      all('.v23-reveal, .v23-reveal-stagger').forEach(function (el) { el.classList.add('is-in'); });
    });
  }

  /* ---------- 2. Hauteur du header visible ---------- */
  function initStickyTop() {
    var head = doc.querySelector('[data-v23-header]') || doc.querySelector('.head') || doc.querySelector('header');
    if (!head) return;
    var last = -1;
    var ticking = false;
    function measure() {
      ticking = false;
      var r = head.getBoundingClientRect();
      var pos = window.getComputedStyle(head).position;
      var top = (pos === 'sticky' || pos === 'fixed') ? Math.max(0, Math.round(r.bottom)) : 0;
      if (top !== last) {
        last = top;
        root.style.setProperty('--v23-sticky-top', top + 'px');
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(measure); }
    }
    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    /* Le header se masque avec une transition : on remesure à la fin. */
    head.addEventListener('transitionend', onScroll);
  }

  /* ---------- 3. Tiroir de filtres (mobile) ---------- */
  function initFacetsDrawer() {
    var facets = doc.querySelector('[data-facets]');
    if (!facets) return;
    var toggle = facets.querySelector('[data-facets-toggle]');
    var panel = facets.querySelector('[data-facets-panel]');
    if (!toggle || !panel) return;

    var mq = window.matchMedia('(max-width: 768px)');
    var backdrop = doc.createElement('div');
    backdrop.className = 'v23-facets-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    /* Dans la barre collante, le fond et le tiroir partagent le même contexte d'empilement. */
    (facets.closest('[data-plp-bar]') || doc.body).appendChild(backdrop);

    var head = doc.createElement('div');
    head.className = 'v23-facets-head';
    head.innerHTML = '<span class="v23-facets-head__t">Filtres</span>' +
      '<button type="button" class="v23-facets-head__x" aria-label="Fermer les filtres">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    panel.insertBefore(head, panel.firstChild);
    panel.setAttribute('aria-label', 'Filtres');

    function isOpen() { return !panel.hidden; }
    function sync() {
      var on = mq.matches && isOpen();
      backdrop.classList.toggle('is-on', on);
      root.classList.toggle('v23-facets-open', on);
      if (on) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
      }
    }
    function close() {
      if (!isOpen()) return;
      toggle.click(); /* garde la logique de wise.js (aria-expanded, annonce) */
      sync();
      if (mq.matches) toggle.focus();
    }

    /* wise.js ouvre le panneau d'office quand des filtres sont actifs :
       sur mobile, on garde le tiroir fermé au chargement. */
    if (mq.matches && isOpen()) {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      window.setTimeout(function () {
        sync();
        if (mq.matches && isOpen()) {
          var first = panel.querySelector('.v23-facets-head__x');
          if (first) first.focus();
        }
      }, 0);
    });
    head.querySelector('.v23-facets-head__x').addEventListener('click', close);
    backdrop.addEventListener('click', close);
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });
    /* Ordinateur : le panneau déroulant se ferme au clic à l'extérieur. */
    doc.addEventListener('click', function (e) {
      if (mq.matches || !isOpen() || !facets.closest('[data-plp-bar]')) return;
      if (!facets.contains(e.target)) close();
    });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
    sync();
  }

  /* ---------- 4. Neige légère (accueil) ---------- */
  function snowWanted() {
    var holder = doc.querySelector('html[data-snow], body[data-snow]');
    if (!holder) return false;
    var v = holder.getAttribute('data-snow');
    if (v === 'false' || v === '0') return false;
    if (!doc.body.classList.contains('template-index') && holder.getAttribute('data-snow') !== 'all') return false;
    if (reduced) return false;
    var c = navigator.connection;
    if (c && c.saveData) return false;
    return !!window.requestAnimationFrame && !!doc.createElement('canvas').getContext;
  }

  function initSnow() {
    if (!snowWanted()) return;

    var canvas = doc.createElement('canvas');
    canvas.className = 'v23-snow';
    canvas.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var small = window.innerWidth < 768;
    var lowMem = navigator.deviceMemory && navigator.deviceMemory < 4;
    var count = small ? 16 : 38;
    if (lowMem) count = Math.round(count * 0.6);

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0, flakes = [], raf = 0, running = false, visible = true, last = 0;

    function size() {
      w = window.innerWidth;
      h = Math.min(window.innerHeight, 900);
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function flake(top) {
      return {
        x: Math.random() * w,
        y: top ? Math.random() * h : -6,
        r: 0.6 + Math.random() * 1.7,
        vy: 0.18 + Math.random() * 0.45,
        sway: 0.3 + Math.random() * 0.6,
        phase: Math.random() * Math.PI * 2,
        a: 0.25 + Math.random() * 0.5
      };
    }
    function frame(t) {
      raf = 0;
      if (!running) return;
      var dt = last ? Math.min((t - last) / 16.67, 3) : 1;
      last = t;
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.phase += 0.012 * dt;
        f.y += f.vy * dt;
        f.x += Math.sin(f.phase) * f.sway * 0.35 * dt;
        if (f.y > h + 6 || f.x < -10 || f.x > w + 10) { flakes[i] = flake(false); continue; }
        /* fondu vers le bas de la zone */
        var fade = f.y > h * 0.7 ? Math.max(0, 1 - (f.y - h * 0.7) / (h * 0.3)) : 1;
        ctx.globalAlpha = f.a * fade;
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, 6.2832);
        ctx.fill();
      }
      raf = window.requestAnimationFrame(frame);
    }
    function start() {
      if (running || doc.hidden || !visible) return;
      running = true;
      last = 0;
      raf = window.requestAnimationFrame(frame);
    }
    function stop() {
      running = false;
      if (raf) window.cancelAnimationFrame(raf);
      raf = 0;
    }

    size();
    ctx.fillStyle = '#ffffff';
    for (var i = 0; i < count; i++) flakes.push(flake(true));

    doc.addEventListener('visibilitychange', function () { if (doc.hidden) stop(); else start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }).observe(canvas);
    }
    var rt = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { size(); ctx.fillStyle = '#ffffff'; }, 200);
    });
    if (mqReduce && mqReduce.addEventListener) {
      mqReduce.addEventListener('change', function (e) { if (e.matches) { stop(); canvas.remove(); } });
    }
    start();
  }

  ready(function () {
    root.classList.add('v23-js');
    try { initReveal(); } catch (e) { /* jamais bloquant */ }
    try { initStickyTop(); } catch (e) {}
    try { initFacetsDrawer(); } catch (e) {}
    try { initSnow(); } catch (e) {}
  });
})();
